import { TypeResponse } from 'gtd-ng-widget';

export class ProfileResponse extends TypeResponse {
  affiliate: { id: number; name: string };
  id: number;
  name: string;
  comment: string;
  affiliate_group: any;
  created_at: number;
  updated_at: number;
  description: string;
  earning: { id: number; name: string };
  from: string;
  payment_currency: string;
  payment_account: string;
  payment_details: string;
  payment_method: string;
  status: string;
  status_changed_at: string;
  status_changed_at_timestamp: number;
  status_changed_by: number;
  status_changed_by_employee: { id: number; first_name: string; last_name: string };
  status_changed_history: string;
  to: string;
  total: {
    currency: string;
    amount: number;
  };
  total_paid: {
    currency: string;
    amount: number;
  };
  total_commissions: {
    currency: string;
    amount: number;
  };
  type: string;
  invoice_id: any;
  invoice: any;
}
